module.exports = __webpack_public_path__ + "img/9.86781f1f.png";